/**
 * لینکِ ردیابی‌ای که این مرورگر با آن آمد: ‎/r/<code> سرور را به ‎?src=<code>
 * می‌فرستد و این‌جا نگهش می‌داریم.
 *
 * سی روز در حافظه‌ی مرورگر می‌مانَد و سرِ ساختنِ مهمان با /v1/auth/guest به
 * سرور می‌رسد؛ سرور فقط برای دستگاهِ **تازه** منبع می‌نشانَد. لینکِ تازه‌تر جای
 * قبلی را می‌گیرد — آخرین لمس، چون همان لینکِ آخر بود که آدم را آورد.
 *
 * همین کلید و همین قالب را site/auth.js هم می‌نویسد و می‌خوانَد: سایت و /play
 * یک ریشه‌اند و کسی که از صفحه‌ی اول به بازی برود نباید منبعش گم شود.
 */
export const SOURCE_KEY = "bazivan.src";
export const SOURCE_TTL_MS = 30 * 86_400_000;

/** همان قاعده‌ی سرور (`cleanLinkCode`). */
const CODE = /^[a-z0-9][a-z0-9_-]{1,31}$/;

type KV = Pick<Storage, "getItem" | "setItem" | "removeItem">;

function storage(): KV | null {
  try {
    return typeof localStorage !== "undefined" ? localStorage : null;
  } catch {
    return null; // حالتِ ناشناسِ سخت‌گیر
  }
}

/** `?src=` ِ نشانی را نگه می‌دارد. کدِ نامعتبر یا نبودنش چیزی را پاک نمی‌کند. */
export function captureSource(search: string, kv: KV | null = storage(), now = Date.now()): void {
  const c = (new URLSearchParams(search).get("src") ?? "").trim().toLowerCase();
  if (!kv || !CODE.test(c)) return;
  try {
    kv.setItem(SOURCE_KEY, JSON.stringify({ c, t: now }));
  } catch { /* حافظه پر یا بسته */ }
}

/** کدِ زنده، یا "" اگر نیست یا سی روزش گذشته. */
export function pendingSource(kv: KV | null = storage(), now = Date.now()): string {
  if (!kv) return "";
  try {
    const raw = kv.getItem(SOURCE_KEY);
    if (!raw) return "";
    const v = JSON.parse(raw) as { c?: unknown; t?: unknown };
    if (typeof v.c === "string" && CODE.test(v.c) && typeof v.t === "number" && now - v.t <= SOURCE_TTL_MS) return v.c;
    kv.removeItem(SOURCE_KEY);
  } catch { /* قالبِ خراب: انگار نیست */ }
  return "";
}
